import { gql } from "generated-graphql";

export const CUPA_FRAGMENT = gql(/* GraphQL */ `
  fragment CupaFragment on Cupa {
    id
    cupaCode
    displayName
    county
    districtName
    notes
    lepcId
    dueDate
    dueDateIsAnniversary
    lepc {
      ...LepcPicker
    }
  }
`);

export const GET_CUPAS = gql(/* GraphQL */ `
  query cupas($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    cupas(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        ...CupaFragment
      }
      count
    }
  }
`);

export const GET_CUPA = gql(/* GraphQL */ `
  query cupa($id: String!) {
    cupa(id: $id) {
      ...CupaFragment
    }
  }
`);

export const CREATE_CUPA = gql(/* GraphQL */ `
  mutation createCupa($input: CupaInput!) {
    createCupa(input: $input) {
      ...CupaFragment
    }
  }
`);

export const UPDATE_CUPA = gql(/* GraphQL */ `
  mutation updateCupa($id: String!, $input: CupaInput!) {
    updateCupa(id: $id, input: $input) {
      ...CupaFragment
    }
  }
`);

export const DELETE_CUPA = gql(/* GraphQL */ `
  mutation deleteCupa($id: String!) {
    deleteCupa(id: $id) {
      id
      cupaCode
    }
  }
`);
